import styled from 'styled-components';

const ValidationLine = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-30039089__sc-1d45qdh-0"
})([""]);
ValidationLine.displayName = 'ValidationLine';
var ValidationLine$1 = ValidationLine;

export { ValidationLine$1 as V };
//# sourceMappingURL=ValidationLine-df4bd82e.js.map
